import { axiosInstance } from '@/modules/shared/lib/axios';
import { PayrollSettingsQueryModel, PayrollSettingsPayload } from './types';

type Props = {
  companyId: string
  payload: PayrollSettingsPayload
}

export function updatePayrollSettings ({ companyId, payload }: Props) {
    return axiosInstance.post<PayrollSettingsQueryModel>(`/api/${companyId}/configuration/payroll/updatePayroll`, payload);
}
